
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[section]/[title]/[adId]",
      function () {
        return require("private-next-pages/[section]/[title]/[adId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[section]/[title]/[adId]"])
      });
    }
  